import { createContext } from 'react';

export type NotificationSeverity = 'success' | 'error';

export interface NotificationContextValue {
  notifySuccess: (message: string) => void;
  notifyError: (message: string) => void;
}

export const NotificationContext = createContext<NotificationContextValue | null>(null);
